import React, { useState } from 'react'
import { Box, Button } from '@mui/material'
import YouTubeDialog from './YouTubeDialog';

const YoutubeVideo = () => {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Box sx={{
        backgroundImage: `url(/images/video-bg/video-bg-scaled.jpg)`,
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        position: 'relative',
        zIndex: '1',
        height: {md:'750px',sm:'450px',xs:'auto'},
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',         
      }}>
        <Button onClick={handleClickOpen}>
          <img className='play' src='/images/video-bg/play.svg' />
        </Button>
        <YouTubeDialog open={open} onClose={handleClose} videoId="2j-gJFljfUA" />
      </Box>
    </>
  )
}

export default YoutubeVideo